import type { TaskSettingField } from "@/pages/TaskSetting/TaskSettingPage";
import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  TASK_SETTING: "api/CRM/ActionPointsV1", ///add
  TASK_SETTTING_ADD : "api/CRM/AddActionPointsV1",
  TASK_SETTING_DELETE :(id: number) =>  `api/CRM/DeleteActionPointsV1/${id}`
};

const  getTaskSettings = async ()  : Promise<ApiResponse<TaskSettingField[]>> => {
    const response = await privateRequest.get<ApiResponse<TaskSettingField[]>>(ENDPOINTS.TASK_SETTING);
    return response.data;
}

const addTaskSetting =  async (data :TaskSettingField)  :Promise<ApiResponse<TaskSettingField>> => {
  const  response =await  privateRequest.post<ApiResponse<TaskSettingField>>(ENDPOINTS.TASK_SETTTING_ADD,data) ;
  return response.data;
}
const  deleteTaskSetting  = async (id : number) : Promise<ApiResponse<number>> => {
  const response  =await privateRequest.delete<ApiResponse<number>>(ENDPOINTS.TASK_SETTING_DELETE(id));
  return response.data;
}

const  TaskSettingService = { getTaskSettings,addTaskSetting,deleteTaskSetting}


export default TaskSettingService;